const FORM_ELEMENT_PROPS = {
  props: ['formField', 'currentCampus', 'currentProgram', 'modelValue', 'offerEnabled', 'errors', 'consumerId']
}

export default FORM_ELEMENT_PROPS
